module.exports = __webpack_public_path__ + "static/img/movieposter1.e6d60bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/movieposter1.jpg
// module id = 639
// module chunks = 1